import { c as _c } from "react/compiler-runtime";
import type { Locale } from '../../../../../../../localization/i18n';
import formatRelativeTodayTomorrowDate from '../../../../../../utils/format-relative-today-tomorrow-date';
import ActivityCard from '../ActivityCard';
import type { EventBookableItem } from '../ActivityCard/ActivityCard.types';
interface Props {
  groupDate: string;
  timeZone?: string;
  activities: Array<EventBookableItem>;
  locale: Locale;
  hasPriority: boolean;
}

// TODO - we need a timezone for the city or something
// each activity can kinda leverage the venue's timezone
// but at a grouped level, maybe the city's time zone makes sense.
const ActivityDateGroup = t0 => {
  const $ = _c(17);
  const {
    groupDate,
    activities,
    locale,
    hasPriority: groupHasPriority
  } = t0;
  let t1;
  if ($[0] !== groupDate || $[1] !== locale) {
    t1 = formatRelativeTodayTomorrowDate({
      date: new Date(groupDate),
      locale,
      dateFormatOptions: {
        month: "2-digit",
        day: "2-digit",
        weekday: "short"
      }
    });
    $[0] = groupDate;
    $[1] = locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const formattedDate = t1;
  let t2;
  if ($[3] !== formattedDate) {
    t2 = <h2 className="mb-2 px-2 text-xl font-medium capitalize sm:px-0">{formattedDate}</h2>;
    $[3] = formattedDate;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== activities || $[6] !== groupHasPriority || $[7] !== locale) {
    let t4;
    if ($[9] !== groupHasPriority || $[10] !== locale) {
      t4 = (activity, index) => <ActivityCard key={activity.id} activity={activity} locale={locale} hasPriority={groupHasPriority && index <= 6} />;
      $[9] = groupHasPriority;
      $[10] = locale;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t3 = activities.map(t4);
    $[5] = activities;
    $[6] = groupHasPriority;
    $[7] = locale;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[12] !== t3) {
    t4 = <ul className="grid grid-cols-1 gap-0.5 sm:grid-cols-2 sm:gap-2 lg:grid-cols-3">{t3}</ul>;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t2 || $[15] !== t4) {
    t5 = <div className="flex w-full flex-col gap-1 py-3 sm:px-2">{t2}{t4}</div>;
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export default ActivityDateGroup;